export const preserveParamsOnHashNav = (navigationPath: string): string => {
  if (typeof window === 'undefined') {
    return navigationPath
  }

  const currentSearch = window.location.search
  const hashIndex = navigationPath.indexOf('#')

  if (hashIndex === -1 || !currentSearch) {
    return navigationPath
  }

  // Split on the first '#' so the full fragment (e.g. '#a#b') is kept intact.
  const beforeHash = navigationPath.slice(0, hashIndex)
  const hash = navigationPath.slice(hashIndex + 1)

  if (!hash) {
    return navigationPath
  }

  const isAbsoluteUrl = /^https?:\/\//i.test(beforeHash)
  let targetSearch: string
  let prefix: string

  if (isAbsoluteUrl) {
    let url: URL
    try {
      url = new URL(beforeHash)
    } catch {
      return navigationPath
    }
    if (url.origin !== window.location.origin) {
      return navigationPath // never carry params cross-origin
    }
    targetSearch = url.search
    prefix = `${url.origin}${url.pathname}`
  } else {
    const queryIndex = beforeHash.indexOf('?')
    targetSearch = queryIndex === -1 ? '' : beforeHash.slice(queryIndex)
    prefix = queryIndex === -1 ? beforeHash : beforeHash.slice(0, queryIndex)
  }

  if (!targetSearch) {
    return `${prefix}${currentSearch}#${hash}`
  }

  // Merge: current params first, then the target's own params override on a key conflict.
  const mergedParams = new URLSearchParams(currentSearch)
  new URLSearchParams(targetSearch).forEach((value, key) => {
    mergedParams.set(key, value)
  })

  return `${prefix}?${mergedParams.toString()}#${hash}`
}
